import styled, { css } from 'styled-components';
import { skeletonKeyframes } from '../../const/styles';

export const StyledArrangements = styled.div`
	padding: 2px 10px;
	background: var(--background);
	border-radius: 7px;
`;

interface StyledArrangementProps {
	readonly isActive: boolean;
}
const ArrangmentStyles = css`
	cursor: pointer;
	margin: 10px 0;
	border-radius: 3px;
	padding: 10px 10px 12px;
	background: var(--off-background);
	color: var(--foreground);
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
export const StyledArrangement = styled.div<StyledArrangementProps>`
	${ArrangmentStyles}
	background: ${({ isActive }) => (isActive ? 'var(--foreground)' : 'var(--off-background)')};
	color: ${({ isActive }) => (isActive ? 'var(--background)' : 'var(--foreground)')};
`;

export const SkeletonArrangement = styled.div`
	${ArrangmentStyles}
	height: 19px;
	animation: ${skeletonKeyframes} 1s linear infinite alternate;
`;
